import { RequirementCoreBase } from "./requirement.core.base"


export class RequirementCore extends RequirementCoreBase {

}